<template>
  <div class="libreria">
    <b-sidebar
      id="filterSidebar"
      title="Filtros"
      width="250px"
      sidebar-class="menu-sidebar px-3"
      style="z-index: 1041"
      backdrop
      shadow
    >
      <filter-options ref="filters" :priceList="priceList" :value="filters" @input="filterChanged($event)" />
    </b-sidebar>
    <features />
    <b-row class="mx-0 mt-2">
      <b-col class="d-none d-md-block" cols="3">
        <filter-options ref="filters" :priceList="priceList" :value="filters" @input="filterChanged($event)" />
      </b-col>
      <b-col class="col-12 col-md-9">        
        <div style="margin-top: -3rem;" v-if="filters.category.length === 0 && filters.author.length === 0 && filters.price.min === '' && filters.price.max === '' && filters.filter === '' && filters.discounts.length === 0">
          <main-title title="Destacados del mes" />
          <book-list :items="starrybooks" />
        </div>
        <div class="mt-4 text-right">
          <div class="d-inline-block">
            <b-button-toolbar
              aria-label="Toolbar with button groups and dropdown menu"
            >
              <b-button-group class="d-none d-md-inline-flex mr-1">
                <b-button @click="view = 'list'">
                  <b-icon icon="list" />
                </b-button>
                <b-button @click="view = 'grid'">
                  <b-icon icon="grid-fill" />
                </b-button>
              </b-button-group>
              <b-button v-b-toggle.filterSidebar class="d-inline-flex d-md-none mr-1"><b-icon icon="list" class="mr-2" /> Filtrar</b-button>
              <b-dropdown right text="Ordenar por">
                <b-dropdown-item @click="sort = 'nameAsc'; updateBooks();">Alfabéticamente (A-Z)</b-dropdown-item>
                <b-dropdown-item @click="sort = 'nameDesc'; updateBooks();">Alfabéticamente (Z-A)</b-dropdown-item>
                <b-dropdown-item @click="sort = 'priceAsc'; updateBooks();">Menor precio</b-dropdown-item>
                <b-dropdown-item @click="sort = 'priceDesc'; updateBooks();">Mayor precio</b-dropdown-item>
              </b-dropdown>
            </b-button-toolbar>
          </div>
        </div>
        <b-nav tabs fill class="mt-3 libraryTabs d-none">
          <b-nav-item active>Nuestros libros</b-nav-item>
          <b-nav-item>Otras editoriales</b-nav-item>
        </b-nav>
        <main-title :title="shopTitle" />
        <transition name="fade">
          <book-page :items="storebooks" :combos="combos" :showPrices="true" :maxpage="maxpage" :page="currentPage" @change="setPage($event);" :view="view" v-if="displaylist" />
        </transition>
      </b-col>
    </b-row>
    <div class="d-block d-md-none mt-5 p-3" style="background: #c8c3c240; border-radius: 1rem;">
      <div style="font-size: 16px; font-weight: 500; margin-bottom: .1rem;">
        Lista de precios
      </div>
      <div style="font-family: 'Nunito Sans', sans-serif; font-size: 14px;">
        Consultá nuestro catálogo descargándolo acá
        <div
          class="border-top border-bottom my-2 py-2"
          style="font-weight: bold;"
        >
          Lista vigente al {{ priceList.vigency }}
          <b-button
            class="rounded-circle float-right"
            style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
            @click="openLink(priceList.file)"
          >
            <b-icon icon="chevron-right" />
          </b-button>
        </div>
      </div>
    </div>
    <div class="d-block d-md-none mt-3 p-3" style="background: #c8c3c240; border-radius: 1rem;">
      <div style="font-size: 16px; font-weight: 500; margin-bottom: .1rem;">
        Distribuidores/Librerías
      </div>
      <div style="font-family: 'Nunito Sans', sans-serif; font-size: 14px;">
        También podés encontrar los libros de La Crujía en:
        <div class="my-2 py-2 text-right" style="font-weight: bold;">
          Ver más detalles
          <b-button
            class="rounded-circle"
            style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
            to="/distribuidores"
          >
            <b-icon icon="chevron-right" />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FilterOptions from "@/components/FilterOptions.vue";
import Features from "@/components/Features.vue";
import MainTitle from "@/components/MainTitle.vue";
import BookList from "@/components/BookList.vue";
import BookPage from "@/components/BookPage.vue";
import axios from "axios";

export default {
  name: "Libreria",
  components: {
    FilterOptions,
    Features,
    MainTitle,
    BookList,
    BookPage
  },
  data() {
    return {
      filters: {
        author: [],
        category: [],
        discounts:[],
        price: {
          min: "",
          max: ""
        },
        filter: ''
      },
      starrybooks: [],
      storebooks: [],
      combos: [],
      maxpage: 1,
      currentPage: 1,
      sort: 'nameAsc',
      view: 'grid',
      displaylist: true,
      priceList: {
        file: null,
        vigency: null
      }
    };
  },
  computed: {
    demo: function() {
      const result = [];
      for (let page = 0; page < 2; page++) {
        for (let bookData = 1; bookData < 5; bookData++) {
          result.push({
            imgCover: "img/7.png",
            bookTitle: "Comunicación y periodismo",
            bookDesc: "Sivana Comba y Edgardo Toledo",
            bookId: bookData + page * 4,
            size: 33
          });
        }
      }
      return result;
    },
    shopTitle: function(){
      // this.updateBooks();
      if (this.filters.category.length === 0 && this.filters.author.length === 0 && this.filters.price.min === "" && this.filters.price.max === "" && this.filters.filter === "" && this.filters.discounts.length === 0 ){
        return 'Todos los libros';
      }else{
        /*
        const categories = this.$refs.filters.categories;
        if (categories[this.filters.category]){
          return categories[this.filters.category].name;
        }else{
          let name = '';
          for(const category in categories){
            if (categories[category].childs.length !== 0){              
              categories[category].childs.forEach((element) => {                
                if (parseInt(element.id) === parseInt(this.filters.category)){
                  name = element.name;
                }
              });
            }
          }
          return name;
        }
        */
        return 'Libros seleccionados';
      }
    }
  },
  mounted(){
    if(this.$route.params.search){
      this.filters.filter = this.$route.params.search;
    }
    if (this.$route.query.promo){
      this.filters.discounts.push(this.$route.query.promo);
    }
    this.updateStarryBooks();
    this.$root.$on('search', data => {
      this.filters.filter = this.$route.params.search;
      this.updateBooks();
    });
    this.getPriceList();
    this.getCombos();
  },
  methods:{
    async updateBooks(){
      this.displaylist = false;
      console.log(this.$store.state.user.siteData);

      this.storebooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify(Object.assign({page: this.currentPage, sort: this.sort},this.filters)),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              bookStock: parseInt(element.stock),
              regularCost: parseInt(element.regularcost),
              size: 33,
              promo: element.promo
            });
          });
          this.maxpage = Math.floor(evtResponse.data.totalrecords / 12) + 1;
          setTimeout(function(){
            this.displaylist = true;
          }.bind(this), 500);
          return result;
        });
    },
    async updateStarryBooks() {
      console.log(this.$store.state.user.siteData);

      this.starrybooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ type: "news" }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              bookStock: parseInt(element.stock),
              regularCost: parseInt(element.regularcost),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
    },
    async getPriceList(){
      await axios
        .post(
          this.$store.state.user.siteData.location + "items/pricelist/getForStore",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.priceList = {
            file: this.$store.state.user.siteData.location + 'repository/pricelists/' + evtResponse.data.records[0].name,
            vigency: evtResponse.data.records[0].vigency
          };
          return true;
        });
    },
    async getCombos(){
      await axios
        .post(
          this.$store.state.user.siteData.location + "items/combos/getForStore",
          JSON.stringify({ filter: this.filters }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/combos/" +
                element.id,
              bookTitle: element.name,
              bookDesc: '',
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: '',
              bookPrice: parseInt(element.price),
              bookStock: parseInt(element.stock),
              regularCost: parseInt(element.price),
              size: 33,
              promo: null
            });
          });
          this.combos = result;
          return true;
        });
    },
    setPage(pageNumber){
      this.currentPage = pageNumber;
      this.updateBooks();
    },
    filterChanged(data){
      this.filters = data;
      this.currentPage = 1;
      this.updateBooks();
    },
    openLink(link){
      window.open(link);
    }
  }
};
</script>
